export default "__VITE_ASSET__Dk0qQPhQ__ 640w, __VITE_ASSET__j1d6BzFt__ 1024w, __VITE_ASSET__C_4ltizl__ 1920w";